const getters = {
    info: state => state.user.info,
    name: state => state.user.name,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    orderItem: state => state.order.order_item_info
}

export default getters
